// src/LoginData/Reports/portabilitySale/PortabilitySaleFilter.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_URL_HEADER;
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

function PortabilitySaleFilter({ onSubmit }) {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCurrent = async () => {
            try {
                const [mRes, yRes] = await Promise.all([
                    axios.get(`${API_BASE}/Common/currentMonth`),
                    axios.get(`${API_BASE}/Common/currentYear`)
                ]);
                const m = String(mRes.data).padStart(2, '0');
                const y = String(yRes.data);
                setMonth(m);
                setYear(y);
            } catch (err) {
                const now = new Date();
                setMonth(String(now.getMonth() + 1).padStart(2, '0'));
                setYear(now.getFullYear());
            } finally {
                setLoading(false);
            }
        };
        loadCurrent();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (month && year && typeof onSubmit === 'function') {
            onSubmit(month, year);
        }
    };

    const years = [new Date().getFullYear(), new Date().getFullYear() - 1];


    return (
        <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>

            <tbody>
                <tr class="tableheader">
                    <th colSpan="6" >
                        Ration Card Drawl Percentage
                    </th>
                </tr>
                <tr >
                    <td><strong>Month:</strong></td>
                    <td>
                        <select value={month} onChange={(e) => setMonth(e.target.value)}
                        >
                            {monthNames.map((name, i) => {
                                const val = String(i + 1).padStart(2, '0');
                                return <option key={val} value={val}>{name}</option>;
                            })}
                        </select>
                    </td>
                    <td><strong>Year:</strong></td>
                    <td>
                        <select value={year} onChange={(e) => setYear(e.target.value)}
                        >
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </td>
                    <td colSpan="2">
                        <button onClick={handleSubmit}
                            class="button button2">
                            Submit
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default PortabilitySaleFilter;